// extracted by mini-css-extract-plugin
export default {"wrapper":"Wp-z","response":"Xp-z","error":"Yp-z","disabled":"Zp-z","buttons":"_p-z","feedbackQuestionSection":"aq-z","yesNoWrapper":"bq-z"};